// src/hooks/useGuestData.js
import { useEffect, useState } from 'react';

export default function useGuestData(search, propertyId) {
  const [guests, setGuests] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchGuests = async () => {
      setLoading(true);
      try {
        if (!propertyId) {
          console.warn('[GuestFetch] No propertyId provided');
          setGuests([]);
          return;
        }

        console.log('✅ REACT_APP_API_URL:', process.env.REACT_APP_API_URL);
        const apiBaseUrl = process.env.REACT_APP_API_URL;
        const url = `${apiBaseUrl}/api/user/search?query=${search}&propertyId=${propertyId}`;
        const response = await fetch(url);
        const data = await response.json();
        setGuests(data.users || []);
      } catch (err) {
        console.error('Failed to fetch guests:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchGuests();
  }, [search, propertyId]);

  return { guests, loading };
}